module.exports = __webpack_public_path__ + "static/img/solution_pro1.bca4335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution_pro1.png
// module id = NZT5
// module chunks = 1